export interface Story {
  id: number;
  name: string;
  neighborhood: string;
  service: string;
  date: string;
  hasPhotos: boolean;
  title: string;
  bodyEn: string;
  bodyEs: string;
}

export const stories: Story[] = [
  {
    id: 1,
    name: "Nadège Chevalier",
    neighborhood: "Coral Gables",
    service: "Window Hardware Repair",
    date: "2025-03-15",
    hasPhotos: true,
    title: "Worn hardware replaced on 8 windows in a 1940s Coral Gables home",
    bodyEn:
      "Replaced worn hardware on 8 existing windows in our 1940s Coral Gables home. New balances, locks, and operators installed same day. Windows that had not opened in years now glide smoothly. Crew was punctual and careful with original trim.",
    bodyEs:
      "Reemplazamos herrajes gastados en 8 ventanas existentes de nuestra casa de los años 40 en Coral Gables. Nuevos balances, cerraduras y operadores instalados el mismo día. Ventanas que no se abrían en años ahora se deslizan suavemente. El equipo fue puntual y cuidadoso con la moldura original.",
  },
  {
    id: 2,
    name: "Sebastián Quintanilla",
    neighborhood: "Brickell",
    service: "Sliding Door Repair",
    date: "2025-03-10",
    hasPhotos: false,
    title: "Stuck balcony slider fixed same day in a Brickell condo tower",
    bodyEn:
      "My 12-foot sliding glass door would not budge — rollers corroded from salt air. Called 9am, tech arrived 2pm same day. Replaced roller assemblies, cleaned bottom track, adjusted alignment. Door glides with one finger now. Charged exactly the phone quote.",
    bodyEs:
      "Mi puerta corrediza de vidrio de 12 pies no se movía — los rodillos estaban corroídos por el aire salino. Llamé a las 9am, el técnico llegó a las 2pm el mismo día. Reemplazó los ensamblajes de rodillos, limpió el riel inferior, ajustó la alineación. La puerta ahora se desliza con un dedo. Cobraron exactamente la cotización telefónica.",
  },
  {
    id: 3,
    name: "Kwame Asante-Mensah",
    neighborhood: "Doral",
    service: "Window Cleaning & Maintenance",
    date: "2025-02-22",
    hasPhotos: false,
    title: "Annual cleaning and hardware tune-up for 11 windows",
    bodyEn:
      "Annual window cleaning and hardware maintenance for our Doral home's 11 windows. Removed built-up salt residue, lubricated all tracks and balances, tightened loose fasteners. Also replaced two worn lock cylinders. Service took about 3 hours. Windows look and operate noticeably better.",
    bodyEs:
      "Limpieza anual de ventanas y mantenimiento de herrajes para las 11 ventanas de nuestra casa en Doral. Removieron residuo de sal acumulado, lubricaron todos los rieles y balances, ajustaron sujetadores sueltos. También reemplazaron dos cilindros de cerradura gastados. El servicio tomó unas 3 horas. Las ventanas lucen y operan notablemente mejor.",
  },
  {
    id: 4,
    name: "Yolanda Brathwaite",
    neighborhood: "Aventura",
    service: "Glass Replacement",
    date: "2025-02-28",
    hasPhotos: true,
    title: "Shattered glass replaced without replacing the entire window unit",
    bodyEn:
      "Landscaper's rock cracked a pane in our living room window. Two companies wanted to replace the whole unit at $1,800. These folks confirmed the frame was intact, measured precisely, and ordered just the replacement glass pane. Total $640. Glass arrived in 9 days, installed in 90 minutes. Honest assessment saved us over a thousand.",
    bodyEs:
      "La roca de un jardinero agrietó un vidrio en nuestra ventana del salón. Dos compañías querían reemplazar toda la unidad por $1,800. Ellos confirmaron que el marco estaba intacto, midieron con precisión y ordenaron solo el vidrio de reemplazo. Total $640. El vidrio llegó en 9 días, instalado en 90 minutos. Una evaluación honesta nos ahorró más de mil.",
  },
  {
    id: 5,
    name: "Inez Heinrich",
    neighborhood: "Miami Beach",
    service: "Emergency Board-Up",
    date: "2025-02-18",
    hasPhotos: true,
    title: "2am emergency call after break-in attempt — secured within 90 minutes",
    bodyEn:
      "Ground floor window cracked after an attempted break-in during the night. Called the emergency line at 2:15am, technician with board-up kit arrived by 3:30am. Secured the opening with plywood and lag bolts properly. Returned 3 days later to replace the glass in the existing frame. Professional from start to finish.",
    bodyEs:
      "Ventana del primer piso agrietada tras un intento de allanamiento durante la noche. Llamé a la línea de emergencia a las 2:15am, el técnico con kit de tapiado llegó a las 3:30am. Aseguró la abertura con contrachapado y pernos de anclaje apropiadamente. Regresó 3 días después para reemplazar el vidrio en el marco existente. Profesional de principio a fin.",
  },
  {
    id: 6,
    name: "Tarun Venkatesh",
    neighborhood: "Pinecrest",
    service: "Weatherstripping & Sealing",
    date: "2025-02-12",
    hasPhotos: true,
    title: "Drafty bedrooms sealed with marine-grade weatherstripping",
    bodyEn:
      "Three bedrooms had noticeable drafts around the window frames during cold fronts. Tech inspected all perimeter seals, found compressed and cracked weatherstripping on most windows. Replaced with marine-grade compression seals in one afternoon. Rooms are noticeably warmer and quieter now. No more whistling on windy nights.",
    bodyEs:
      "Tres dormitorios tenían corrientes notables alrededor de los marcos durante frentes fríos. El técnico inspeccionó todos los sellos perimetrales, encontró burletes comprimidos y agrietados en la mayoría de las ventanas. Reemplazó con sellos de compresión de calidad marina en una tarde. Las habitaciones son notablemente más cálidas y silenciosas ahora. No más silbido en noches ventosas.",
  },
  {
    id: 7,
    name: "Olamide Adetokunbo",
    neighborhood: "Kendall",
    service: "Window Hardware Repair",
    date: "2025-02-05",
    hasPhotos: false,
    title: "Failed balance mechanism repaired — window stays open again",
    bodyEn:
      "Window in our kitchen would not stay open — the balance mechanism had failed completely. Thought we might need a new window. Their tech showed me the issue, replaced both channel balances, and lubricated the sash tracks. Window now stays open at any position. Total cost under $200. Honest diagnosis saved us from unnecessary replacement.",
    bodyEs:
      "La ventana de nuestra cocina no se mantenía abierta — el mecanismo de balance había fallado por completo. Pensé que necesitaríamos una ventana nueva. Su técnico me mostró el problema, reemplazó ambos balances de canal y lubricó los rieles del sash. La ventana ahora se mantiene abierta en cualquier posición. Costo total bajo $200. Un diagnóstico honesto nos salvó de un reemplazo innecesario.",
  },
  {
    id: 8,
    name: "Bronwyn Pelletier",
    neighborhood: "Bay Harbor Islands",
    service: "Glass Replacement",
    date: "2025-01-30",
    hasPhotos: true,
    title: "Cracked tabletop and foggy bathroom glass replaced same week",
    bodyEn:
      "Cracked tabletop glass in our dining room and foggy bathroom window both needed attention. Measured Tuesday, cut to size Wednesday, installed Thursday morning. Both pieces fit perfectly in the existing frames. Clean work, no mess left behind. Pleased with the precision.",
    bodyEs:
      "Vidrio agrietado de la mesa del comedor y ventana empañada del baño ambos necesitaban atención. Midieron el martes, cortaron a medida el miércoles, instalaron el jueves por la mañana. Ambas piezas encajaron perfectamente en los marcos existentes. Trabajo limpio, no dejaron desorden. Satisfecho con la precisión.",
  },
  {
    id: 9,
    name: "Raphael Oduya",
    neighborhood: "North Miami Beach",
    service: "Glass Replacement",
    date: "2025-01-24",
    hasPhotos: false,
    title: "Foggy double-pane glass replaced in three windows",
    bodyEn:
      "Seal failure on three windows caused condensation between the panes. Tech confirmed the outer glass and frames were fine, only the insulated glass unit needed replacement. Ordered custom-sized units, installed three weeks later. No more foggy windows. Clean, careful installation.",
    bodyEs:
      "Falla de sello en tres ventanas causó condensación entre los vidrios. El técnico confirmó que el vidrio exterior y los marcos estaban bien, solo la unidad de vidrio aislado necesitaba reemplazo. Ordenó unidades a medida, instaló tres semanas después. No más ventanas empañadas. Instalación limpia y cuidadosa.",
  },
  {
    id: 10,
    name: "Esperanza Villalobos-Reyes",
    neighborhood: "South Miami",
    service: "Window Hardware Repair",
    date: "2025-01-18",
    hasPhotos: true,
    title: "1970s window hardware overhauled — every sash operates smoothly",
    bodyEn:
      "Our 1970s windows had failing operators and stuck sashes throughout the house. Tech replaced all operators, balances, and locks over two visits. Also adjusted strike plates so latches engage properly. Every window now opens and closes smoothly. The house feels more secure and functional.",
    bodyEs:
      "Nuestras ventanas de los años 70 tenían operadores fallidos y sash atascados en toda la casa. El técnico reemplazó todos los operadores, balances y cerraduras en dos visitas. También ajustó las placas de contacto para que los pestillos encajen correctamente. Cada ventana ahora se abre y cierra suavemente. La casa se siente más segura y funcional.",
  },
  {
    id: 11,
    name: "Magnus Tørresdal",
    neighborhood: "Key Biscayne",
    service: "Sliding Door Repair",
    date: "2025-01-11",
    hasPhotos: false,
    title: "Three sliding doors serviced in one visit",
    bodyEn:
      "Key Biscayne salt air destroys hardware fast. They serviced all three of our sliders in one visit: new stainless rollers, new lock cylinders, new weatherstripping. Doors operate like new. Now on their annual maintenance plan.",
    bodyEs:
      "El aire salino de Key Biscayne destruye los herrajes rápido. Atendieron las tres corredizas en una visita: nuevos rodillos de acero inoxidable, nuevos cilindros de cerradura, nuevos burletes. Las puertas operan como nuevas. Ahora en su plan anual de mantenimiento.",
  },
  {
    id: 12,
    name: "Chiamaka Eze-Williams",
    neighborhood: "Coconut Grove",
    service: "Window Cleaning & Maintenance",
    date: "2025-01-05",
    hasPhotos: true,
    title: "Preventive maintenance saved us from major repair",
    bodyEn:
      "During the annual tune-up they caught early signs of roller wear on our patio slider. Replaced the rollers before failure for the cost of one repair call. Annual maintenance is paying for itself.",
    bodyEs:
      "Durante la puesta a punto anual detectaron señales tempranas de desgaste de rodillos en nuestra corrediza del patio. Reemplazaron los rodillos antes de la falla por el costo de una visita de reparación. El mantenimiento anual se está pagando solo.",
  },
  {
    id: 13,
    name: "Apolline Sauvageau",
    neighborhood: "Aventura",
    service: "Window Hardware Repair",
    date: "2024-12-28",
    hasPhotos: false,
    title: "Lock mechanism replaced on bedroom windows",
    bodyEn:
      "Two bedroom window locks stopped engaging properly. They confirmed scope by phone, brought replacement locks, completed both in 30 minutes. Honest flat-rate pricing for a small job.",
    bodyEs:
      "Dos cerraduras de ventana de dormitorio dejaron de encajar correctamente. Confirmaron el alcance por teléfono, trajeron cerraduras de reemplazo, completaron ambas en 30 minutos. Tarifa plana honesta para un trabajo pequeño.",
  },
  {
    id: 14,
    name: "Demetri Karagiannis",
    neighborhood: "Brickell",
    service: "Emergency Board-Up",
    date: "2024-12-20",
    hasPhotos: true,
    title: "Pre-storm emergency board-up for cracked window",
    bodyEn:
      "Hurricane warning issued, a window had a crack from a prior incident. Called 6am, tech arrived by noon. Reinforced with hurricane plywood and through-bolted lag screws. Held through 95mph gusts.",
    bodyEs:
      "Alerta de huracán emitida, una ventana tenía una grieta de un incidente previo. Llamé a las 6am, el técnico llegó al mediodía. Reforzó con contrachapado para huracán y pernos de anclaje. Resistió ráfagas de 95 mph.",
  },
  {
    id: 15,
    name: "Whitney Babcock-Jorgensen",
    neighborhood: "Coral Gables",
    service: "Window Cleaning & Maintenance",
    date: "2024-12-14",
    hasPhotos: false,
    title: "Annual maintenance for historic Coral Gables home",
    bodyEn:
      "Our 1940s Coral Gables home needs careful maintenance. They cleaned all tracks, lubricated hinges, checked weatherstripping, tightened loose hardware. Written report on what to watch. Booked for next year already.",
    bodyEs:
      "Nuestra casa de los años 40 en Coral Gables necesita mantenimiento cuidadoso. Limpiaron todos los rieles, lubricaron bisagras, revisaron burletes, ajustaron herrajes sueltos. Informe escrito sobre qué vigilar. Ya reservamos para el próximo año.",
  },
  {
    id: 16,
    name: "Folake Akinwale",
    neighborhood: "Miami Beach",
    service: "Weatherstripping & Sealing",
    date: "2024-12-08",
    hasPhotos: false,
    title: "Door sweep replacement stopped water intrusion",
    bodyEn:
      "Heavy rain was getting under our patio door. They replaced the worn door sweep and added caulking at the threshold. No more water intrusion through the next two rainstorms.",
    bodyEs:
      "Lluvias fuertes entraban bajo nuestra puerta del patio. Reemplazaron el burlete gastado y agregaron sellado en el umbral. No más filtraciones de agua en las siguientes dos tormentas.",
  },
  {
    id: 17,
    name: "Beauregard Thibodeaux",
    neighborhood: "Doral",
    service: "Window Hardware Repair",
    date: "2024-12-01",
    hasPhotos: true,
    title: "Handle and lock replaced on sliding patio door",
    bodyEn:
      "Slider handle came off and lock would not engage. They diagnosed worn handle assembly and worn strike plate. Replaced both, adjusted alignment. Quick honest service, same-day completion.",
    bodyEs:
      "La manija de la corrediza se cayó y la cerradura no encajaba. Diagnosticaron el ensamblaje de manija gastado y la placa de contacto desgastada. Reemplazaron ambos, ajustaron la alineación. Servicio rápido y honesto, completado el mismo día.",
  },
  {
    id: 18,
    name: "Anastasija Dragićević",
    neighborhood: "Pinecrest",
    service: "Glass Replacement",
    date: "2024-11-24",
    hasPhotos: false,
    title: "Cabinet glass replaced in china cabinet",
    bodyEn:
      "Glass shelf shattered in our display cabinet. They came out, measured, ordered tempered glass cut to size, installed. Four business days from order to install.",
    bodyEs:
      "El estante de vidrio se quebró en nuestro mueble de exhibición. Vinieron, midieron, ordenaron vidrio templado a medida, lo instalaron. Cuatro días hábiles de orden a instalación.",
  },
  {
    id: 19,
    name: "Solomon Wachira-Njoroge",
    neighborhood: "Kendall",
    service: "Window Cleaning & Maintenance",
    date: "2024-11-17",
    hasPhotos: true,
    title: "Comprehensive maintenance plan for whole home",
    bodyEn:
      "31 windows in our Kendall home, all needed attention. Comprehensive maintenance over 2 visits: cleaning, lubrication, hardware check, weatherstripping inspection. Report identified 3 items for future repair.",
    bodyEs:
      "31 ventanas en nuestra casa de Kendall, todas necesitaban atención. Mantenimiento integral en 2 visitas: limpieza, lubricación, revisión de herrajes, inspección de burletes. El informe identificó 3 elementos para reparación futura.",
  },
  {
    id: 20,
    name: "Tahira Bhattacharya",
    neighborhood: "South Miami",
    service: "Window Hardware Repair",
    date: "2024-11-10",
    hasPhotos: false,
    title: "Worn slider handle replaced quickly",
    bodyEn:
      "Sliding door handle assembly worn out. Tech diagnosed worn parts, replaced the handle and adjusted the strike plate. 45 minutes on-site total. Honest flat-rate pricing for a small job.",
    bodyEs:
      "El ensamblaje de manija de la puerta corrediza estaba gastado. El técnico diagnosticó partes gastadas, reemplazó la manija y ajustó la placa de contacto. 45 minutos en total en el sitio. Tarifa plana honesta para un trabajo pequeño.",
  },
];